<div class="mdk-user-menu__userInfo">
  <div class="vl-badge vl-badge--initials vl-badge--small vl-badge--alt vl-badge--custom">
    <span>{{ initials$ | async }}</span>
  </div>
  <mdk-popover title="{{ userName$ | async }}">
    <ul class="vl-popover__link-list">
      <li (click)="onLogOut()" class="vl-popover__link-list__item">
        <a class="vl-link vl-link--block">Afmelden</a>
      </li>
    </ul>
  </mdk-popover>
</div>
